import React, { useState, useEffect } from "react";
import {
	useTable,
	usePagination,
	useSortBy,
	useExpanded,
	useGlobalFilter,
	useRowSelect,
} from "react-table";
import { Button } from "react-bootstrap";
import { ARRIVALREPORT_DATA_COLUMNS } from "../../columns/arrivalReportColumns";
// import MainTablePagination from "./MainTablePagination";
import { getContainerMasterData } from "../../../services/ContainerMasterService";
import { FormatArrivalReportData } from "../../../utils/dataFilter";
import moment from "moment";
import ArrivalReportActionCenter from "../action-center/ArrivalReportActionCenter";
import { exportData } from "../../../utils/helpers";
import { getUser } from "../../../services/authService";
import { toast } from "react-toastify";
import store from "../../../store/Store";
import { dispatcher } from "../../../store/storeHelpers";
import * as actionTypes from "../../../store/ActionTypes";
import { defaultArrivalReportColumn } from "../cells/editable/arrivalReportEditableCell";
import {
	insertTractorContainerData,
	insertAggregateContainerData,
	insert5MContainerData,
} from "../../../services/ContainerMasterService";
import { filter } from "lodash";
import MainTablePaginationAdv from "./MainTablePaginationAdv";
import noDataAvailable from "../../../assets/img/noDataAvailable.png";
import { TableCheckbox } from "./TableCheckbox";
import { PulseLoader } from "react-spinners";

function ArrivalReportTable({ setGetInCounterData, filteredUserAccessData }) {
	const user = getUser();
	const [columns] = useState(ARRIVALREPORT_DATA_COLUMNS);
	const [date, setDate] = useState({
		fromdate: moment().format("YYYY-MM-DD"),
		todate: moment().format("YYYY-MM-DD"),
	});
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [noDataState, setNoDataState] = useState(false);
	const [disableGateInBtn, setDisableGateInBtn] = useState(false);

	var allowToEdit = filter(filteredUserAccessData, { Edit: 1 }).length > 0;
	var allowToAdd = filter(filteredUserAccessData, { Add: 1 }).length > 0;

	const updateCellDataForFactoryIn = (
		rowIndex,
		columnId,
		dateValue,
		timeValue
	) => {
		setTableData((old) =>
			old.map((row, index) => {
				if (index === rowIndex) {
					return {
						...old[rowIndex],
						[columnId]: `${dateValue}T${timeValue}`,
					};
				}
				return row;
			})
		);
	};

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setTableData(
				Object.values(store.getState().daily_container_arrival_report)
			);
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		async function getData() {
			try {
				setLoading(true);
				setNoDataState(false);
				const response = await getContainerMasterData(date, "Arrival");
				setLoading(false);
				dispatcher(
					actionTypes.ARRIVAL_REPORT_LOAD,
					FormatArrivalReportData(response.data)
				);
			} catch (error) {
				setTableData([]);
				setLoading(false);
				if (error.response.data.StatusCode === 404) {
					setNoDataState(true);
					setGetInCounterData({
						GateIn: "",
						TotalGateIn: "",
					})
				}
			}
		}
		getData();
	}, [date,setGetInCounterData]);

	useEffect(() => {
		var gateInDataForCount = [];
		for (let i = 0; i < tableData.length; i++) {
			if (tableData[i]["Gate_In_Date"]) {
				gateInDataForCount.push({
					...tableData[i],
				});
			}
		}
		setGetInCounterData({
			GateIn: gateInDataForCount,
			TotalGateIn: tableData,
		});
	}, [setGetInCounterData, tableData]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		state,
		setPageSize,
		canPreviousPage,
		setGlobalFilter,
		selectedFlatRows,
		prepareRow,
		allColumns,
		getToggleHideAllColumnsProps,
	} = useTable(
		{
			columns,
			data: tableData,
			autoResetPage: false,
			initialState: { pageSize: 50 },
			autoResetExpanded: false,
			autoResetGlobalFilter: false,
			defaultColumn: defaultArrivalReportColumn,
			updateCellDataForFactoryIn,
			allowToEdit,
		},
		useGlobalFilter,
		useSortBy,
		useExpanded,
		usePagination,
		useRowSelect,
		(hooks) => {
			hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) =>              
		  	<div>
                <TableCheckbox {...row.getToggleRowSelectedProps()} />
			</div>
        },
        ...columns,
      ]);
		}
	);
	const { pageIndex, pageSize, globalFilter } = state;
	const dataExportHandler = () => {
		var is_Gate_In_DatePresent = [];
		for (let i = 0; i < tableData.length; i++) {
			if (tableData[i]["Gate_In_Date"]) {
				is_Gate_In_DatePresent.push({
					...tableData[i],
				});
			}
		}
		exportData(
			is_Gate_In_DatePresent.map((item) => {
				return {
					Date: item["Date"] === "Invalid date" ? "" : item["Date"],
					Module: item["DataOf"],
					Factory_In_Date_Time:
						item["Gate_In_Date"] === "Invalid date"
							? ""
							: moment(item["Gate_In_Date"]).format("DD-MM-YYYY HH:mm A"),
					Container_No: item["Container_Number"],
					Seal_No: item["Seal_No"],
					LR_No: item["LR_NO"],
					Vehicle_No: item["Vehicle_No"],
					Carrier: item["Carrier"],
					Clearence: item["Clearence"],
					Dest_Country: item["Dest_Country"],
					Dest_Port: item["Dest_Port"],
					Final_Destination: item["final_destination"],
					Product: item["Product"],
					Booking_No: item["Booking_Number"],
					Transporter: item["Transporter"],
					Pick_Up_Location: item["pick_up_location"],
					SAP_code: item["SAP_code"],
					Container_Type: item["Container_Type"],
					Driver_No: item["Driver_No"],
					Remark: item["Remarks"],
				};
			}),
			`Arrival Report ${moment(date).format("DD/MM/YYYY")}`
		);
	};

	async function actionClickHandler(cell) {
		try {
			// if (!cell.row.original.ContainerMasterId) {
			if (cell.row.original.DataOf === "TRACTOR") {
				setDisableGateInBtn(true);
				await insertTractorContainerData(
					moment().format("YYYY-MM-DD HH:mm:ss"),
					cell.row.original.TransporterDataId,
					cell.row.original.DailyContainerPlanningId
				);
				dispatcher(actionTypes.ARRIVAL_REPORT_GATE_IN, {
					Id: `${cell.row.original["TransporterDataId"]}`,
					columnName: "Gate_In_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD HH:mm:ss"),
					UserId: user.uid,
				});
				setDisableGateInBtn(false);
			}
			if (cell.row.original.DataOf === "AGGREGATE") {
				setDisableGateInBtn(true);
				await insertAggregateContainerData(
					moment().format("YYYY-MM-DD HH:mm:ss"),
					cell.row.original.TransporterDataId,
					cell.row.original.DailyContainerPlanningId
				);
				dispatcher(actionTypes.ARRIVAL_REPORT_GATE_IN, {
					Id: `${cell.row.original["TransporterDataId"]}`,
					columnName: "Gate_In_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD  HH:mm:ss"),
					UserId: user.uid,
				});
				setDisableGateInBtn(false);
			}
			if (cell.row.original.DataOf === "5M") {
				setDisableGateInBtn(true);
				await insert5MContainerData(
					moment().format("YYYY-MM-DD HH:mm:ss"),
					cell.row.original.TransporterDataId,
					cell.row.original.DailyContainerPlanningId
				);
				dispatcher(actionTypes.ARRIVAL_REPORT_GATE_IN, {
					Id: `${cell.row.original["TransporterDataId"]}`,
					columnName: "Gate_In_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD  HH:mm:ss"),
					UserId: user.uid,
				});
				setDisableGateInBtn(false);
			}
			toast.success(
				`"Factory In Date & Time" column updated with "${moment().format(
					"DD-MM-YYYY HH:mm"
				)}"`
			);
			// }
		} catch (error) {
			setDisableGateInBtn(false);
		}
	}
	const cellRenderHandler = (cell) => {
		if (cell.column.id === "Gate_In_Date") return "action";
	};

	return (
		<>
			{loading && (
				<PulseLoader
					color="#007bff"
					size="20px"
					margin="10px"
					style={{ position: "absolute", top: "50vh", left: "45%" }}
				/>
			)}

			{!loading && noDataState && (
				<img
					src={noDataAvailable}
					alt="notAvailableImg"
					// width="630px"
					// height="530px"
					className="noDataFoundImg"
					// style={{marginLeft:"-2%"}}
				/>
			)}
			<div className="table_actions">
				<ArrivalReportActionCenter
					date={date}
					setDate={setDate}
					dataExportHandler={dataExportHandler}
					tableData={tableData}
					allColumns={allColumns}
					getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
					filteredUserAccessData={filteredUserAccessData}
					globalFilter={globalFilter}
					setGlobalFilter={setGlobalFilter}
					selectedFlatRows={selectedFlatRows}
					setNoDataState={setNoDataState}
				/>
			</div>
			{!noDataState && (
				<>
					<div className="table_container_arrival_report">
						<table {...getTableProps()} className="table mtbs">
							<thead>
								{headerGroups.map((headerGroup) => (
									<tr {...headerGroup.getHeaderGroupProps()}>
										{headerGroup.headers.map((column) => (
											<th
												{...column.getHeaderProps(
													column.getSortByToggleProps()
												)}
											>
												{column.render("Header")}
												{column.id !== "selection" && (
													<i
														className={
															column.isSorted
																? column.isSortedDesc
																	? "fi fi-rr-angle-small-down head-icon"
																	: "fi fi-rr-angle-small-up head-icon"
																: "fi fi-rr-circle-small head-icon w"
														}
													></i>
												)}
											</th>
										))}
									</tr>
								))}
							</thead>
							<tbody {...getTableBodyProps()}>
								{page.map((row) => {
									prepareRow(row);
									return (
										<tr {...row.getRowProps()}>
											{row.cells.map((cell) => {
												return (
													<td
														{...cell.getCellProps()}
														className={
															cell.row.subRows.length !== 0
																? "main-row"
																: "sub-row"
														}
													>
														<div className="cell-wrap">
															<span>{cell.render("Cell")}</span>
															{cellRenderHandler(cell) === "action" && (
																<Button
																	className="btn btn-sm btn-tbl gateInBtn"
																	style={{
																		height: "35px",
																		background: "green",
																		position: "relative",
																		left: "0px",
																	}}
																	onClick={() => actionClickHandler(cell)}
																	disabled={
																		cell.row.original.Gate_In_Date ||
																		!allowToAdd ||
																		disableGateInBtn
																	}
																>
																	<i class="bx bx-log-out-circle gateInSymbol"></i>
																</Button>
															)}
														</div>
													</td>
												);
											})}
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
					<MainTablePaginationAdv
						nextPage={nextPage}
						previousPage={previousPage}
						canNextPage={canNextPage}
						pageIndex={pageIndex}
						pageOptions={pageOptions}
						pageSize={pageSize}
						canPreviousPage={canPreviousPage}
						setPageSize={setPageSize}
						gotoPage={gotoPage}
						pageCount={pageCount}
					/>
				</>
			)}
		</>
	);
}

export default ArrivalReportTable;
